import { loadable } from "components/SpruceLoader";

const BuildBaron = loadable(() => import("./BuildBaron"));

export default BuildBaron;
